import classNames from 'classnames';
import { Check } from 'lucide-react';

import styles from './ConnectorStep.module.css';

const steps = [
  {
    id: 1,
    label: '기본 정보 입력',
  },
  {
    id: 2,
    label: '연결 설정',
  },
];

type ConnectorStepProps = {
  step: number;
};

const getDotNumber = (step: number, id: number) => {
  if (step === 2 && id === 1) return <Check size={16} />;
  return id;
};

export const ConnectorStep = ({ step }: ConnectorStepProps) => {
  return (
    <ol className={styles.stepTrack}>
      {steps.map((stepItem) => (
        <li
          key={stepItem.id}
          className={classNames(styles.stepItem, { [styles.stepItemActive]: stepItem.id === step })}>
          <div className={styles.stepDot}>
            <span className={styles.stepDotNumber}>{getDotNumber(step, stepItem.id)}</span>
          </div>
          <span className={styles.stepLabel}>{stepItem.label}</span>
        </li>
      ))}
    </ol>
  );
};
